import { APP_INITIALIZER, ErrorHandler, Injectable, Provider } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, first } from 'rxjs';

import { isChunkLoadError, markNavigationSucceeded, reloadAfterChunkError } from './chunk-reload';

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        if (isChunkLoadError(error)) {
            if (!reloadAfterChunkError()) {
                console.error('ChunkLoadError persisted after reload:', error);
            }
        } else {
            console.error(error);
        }
    }
}

export function trackFirstNavigation(router: Router): () => void {
    return () => {
        router.events.pipe(filter(event => event instanceof NavigationEnd), first()).subscribe(() => markNavigationSucceeded());
    };
}

/** meldet dem ChunkErrorHandler die erste erfolgreiche Navigation (ab dann `reload()` statt Einstiegs-URL) */
export const CHUNK_RELOAD_NAVIGATION_TRACKER: Provider = {
    provide: APP_INITIALIZER,
    useFactory: trackFirstNavigation,
    deps: [Router],
    multi: true,
};
